import { render, staticRenderFns } from "./backTop.vue?vue&type=template&id=ff7ac434&scoped=true"
import script from "./backTop.vue?vue&type=script&lang=js"
export * from "./backTop.vue?vue&type=script&lang=js"
import style0 from "./backTop.vue?vue&type=style&index=0&id=ff7ac434&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff7ac434",
  null
  
)

export default component.exports